class ShippingScheduler {
    constructor() {
        this.parisTimezone = 'Europe/Paris';
    }

    getCurrentUTC() {
        return new Date(new Date().toUTCString());
    }

    getParisOffset() {
        const now = new Date();
        const parisTime = new Date(now.toLocaleString('en-US', { timeZone: this.parisTimezone }));
        return (parisTime.getTime() - now.getTime()) / (60 * 1000);
    }

    getParisTime() {
        let utc = this.getCurrentUTC();
        const parisOffset = this.getParisOffset();
        return new Date(utc.getTime() + parisOffset * 60 * 1000);
    }

    getNextBusinessDay(parisTime, locale) {
        const nextDay = new Date(parisTime);
        nextDay.setDate(parisTime.getDate() + 1);

        const dayOfWeek = nextDay.getUTCDay();
        if (dayOfWeek === 6) { // Saturday
            nextDay.setDate(nextDay.getDate() + 2);
        } else if (dayOfWeek === 0) { // Sunday
            nextDay.setDate(nextDay.getDate() + 1);
        }

        const options = { weekday: 'long' };
        return nextDay.toLocaleDateString(locale, options);
    }

    getShippingTime(clientTime, shippingType, locale) {
        const parisTime = this.getParisTime();

        let cutoffHour;
        if (shippingType === 'urgent') {
            cutoffHour = 12; // 12 PM Noon
        } else if (shippingType === 'standard') {
            cutoffHour = 12; // 12 PM Noon
        } else {
            throw new Error("Invalid shipping type");
        }

        const cutoffTime = new Date(parisTime);
        cutoffTime.setHours(cutoffHour, 0, 0, 0);

        if (parisTime.getDay() === 6 || parisTime.getDay() === 0) {
            // If it's Saturday or Sunday
            return this.getNextBusinessDay(parisTime, locale);
        } else if (parisTime.getTime() < cutoffTime.getTime()) {
            return "today";
        } else {
            return "tomorrow";
        }
    }

    timeRemaining(clientTime, shippingType, locale) {
        const parisTime = this.getParisTime();

        // Check if it's a non-shipping day
        if (parisTime.getDay() === 6 || parisTime.getDay() === 0) {
            return null;
        }

        let cutoffHour;
        if (shippingType === 'urgent') {
            cutoffHour = 12; // 12 PM Noon
        } else if (shippingType === 'standard') {
            cutoffHour = 12; // 12 PM Noon
        } else {
            throw new Error("Invalid shipping type");
        }

        const cutoffTime = new Date(parisTime);
        cutoffTime.setHours(cutoffHour, 0, 0, 0);

        const timeDifference = cutoffTime - parisTime;
        const hoursRemaining = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutesRemaining = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

        if (hoursRemaining < 3 && timeDifference > 0) {
            if (hoursRemaining > 0) {
                return `${hoursRemaining} ${hoursRemaining > 1 ? 'hours' : 'hour'}`;
            } else {
                return `${minutesRemaining} ${minutesRemaining > 1 ? 'minutes' : 'minute'}`;
            }
        }

        return null;
    }
}